<template>
    <div id="tzgg-body" ref="tzggElement">
        <CCBlockFrame :header="header">
            <ul v-if="dataList.length > 0" id="item-body" class="autoStyle">
                <template class="link-message">
                    <li v-for="(item, index) in dataList" :key="index" class="link-message" @click="onCellLink(item, index)">
                        <div class="item">
                            <!-- <div v-if="item.readed=='0'" class="title" style="font-weight:700;"><span style="display:flex;"><span style="display: block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.flSubject }}</span> <span style="line-height: 30px;"><svg-icon style="color: #9B9B9B;font-size: 20px;" class-name="newT" icon-class="newT" /></span></span></div> -->
                            <div class="title" style="color: #333333">
                                <span class="msg">{{ item.flSubject }}</span>
                            </div>
                            <svg-icon v-if="item.isAttach == 'yes'" style="color: #9b9b9b; float: right" class-name="attachIcon" icon-class="attachIcon" />
                            <div class="bottom">
                                <!-- <span style="text-align:left" class="name">{{ item.wfNodeNames }}</span> -->
                                <span style="text-align: right" class="name">{{ item.flCreateDate }}</span>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <div v-else>
                <div slot="empty" style="text-align: center; margin-top: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span v-text-lbl="'common.noData'" style="font-size: 15px; color: #dbdbdb">暂无数据</span>
                </div>
            </div>
        </CCBlockFrame>
    </div>
</template>

<script>
const moment = require('moment')
const nowTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
import { mapGetters } from 'vuex'
export default {
    name: 'PatyBuildingActivities',
    components: {},
    filters: {
        dateTrans(date) {
            if (!date) return ''
            return window.moment(date).format('YYYY-MM-DD HH:mm')
        }
    },
    props: {
        title: { type: String, default: '公告' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            // 全部数据列表
            allDataList: [],
            // 数据列表
            dataList: [],
            header: {
                title: [
                    {
                        // name: '公告',
                        name: this.$tx('ecoa.portal.notice', '公告'),
                        code: 'dzggPublished',
                        click: this.tabClick
                    },
                    {
                        // name: '通知',
                        name: this.$tx('ecoa.portal.inform', '通知'),
                        code: 'dzggPublished',
                        click: this.tabClick
                    },
                    // {
                    //     // name: '表扬',
                    //     name: this.$tx('ecoa.portal.praise', '表扬'),
                    //     code: 'dzggPublished',
                    //     click: this.tabClick
                    // },
                    // {
                    //     // name: '批评',
                    //     name: this.$tx('ecoa.portal.criticize', '批评'),
                    //     code: 'dzggPublished',
                    //     click: this.tabClick
                    // },
                    {
                        // name: '其它',
                        name: this.$tx('ecoa.portal.other', '其他'),
                        code: 'dzggPublished',
                        click: this.tabClick
                    }
                ],
                more: true,
                icon: this.appletData.icon,
                code: 'dzggPublished'
            },
            listdataConfig: {
                // orderBy: 'pushTime desc',
                listpageViewUrl: 'ecoa.dzgg.listPublished',
                pageNum: 1,
                pageSize: 10000,
                order: 'asc',
                urlsearch: `status<:2;endTime>:${nowTime};startTime<:${nowTime}`

                // listpageViewUrl: 'djgl.inforContent.list_yfb.vue',
                // urlsearch: 'flFormName!:通知公告'
            }
        }
    },
    computed: {
        ...mapGetters(['loginUser', 'routes'])
    },
    watch: {},
    created() {
        this.getAllData()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        tabClick(data) {
            this.getTz(data.name)
        },
        async getTz(type) {
            console.log(type, 123)

            this.listdataConfig = {
                // orderBy: 'pushTime desc',
                listpageViewUrl: 'ecoa.dzgg.listPublished',
                pageNum: 1,
                pageSize: 10000,
                order: 'asc',
                urlsearch: `status<:2;endTime>:${nowTime};startTime<:${nowTime}`
                // listpageViewUrl: 'djgl.inforContent.list_yfb.vue',
                // urlsearch: 'flFormName!:通知公告'
            }
            if (type === this.$tx('ecoa.portal.notice', '公告')) {
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhTzggData
                    this.dataList = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
                this.$app.listdata('ecoa/dzgg/listdata', this.listdataConfig).then((res) => {
                    const arrlist = []
                    this.allDataList = res.body.pageInfo.list
                    this.allDataList.forEach((k) => {
                        if (k.type === '公告') {
                            arrlist.push(k)
                        }
                    })
                    this.dataList = arrlist
                })
            } else if (type === this.$tx('ecoa.portal.inform', '通知')) {
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhTzData
                    this.dataList = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
                this.$app.listdata('ecoa/dzgg/listdata', this.listdataConfig).then((res) => {
                    const arrlist = []
                    this.allDataList = res.body.pageInfo.list
                    this.allDataList.forEach((k) => {
                        if (k.type === '通知') {
                            arrlist.push(k)
                        }
                    })
                    this.dataList = arrlist
                })
            } else if (type === this.$tx('ecoa.portal.praise', '表扬')) {
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhByData
                    this.dataList = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
                this.$app.listdata('ecoa/dzgg/listdata', this.listdataConfig).then((res) => {
                    const arrlist = []
                    this.allDataList = res.body.pageInfo.list
                    this.allDataList.forEach((k) => {
                        if (k.type === '表扬') {
                            arrlist.push(k)
                        }
                    })
                    this.dataList = arrlist
                })
            } else if (type === this.$tx('ecoa.portal.criticize', '批评')) {
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhPpData
                    this.dataList = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
                this.$app.listdata('ecoa/dzgg/listdata', this.listdataConfig).then((res) => {
                    const arrlist = []
                    this.allDataList = res.body.pageInfo.list
                    this.allDataList.forEach((k) => {
                        if (k.type === '批评') {
                            arrlist.push(k)
                        }
                    })
                    this.dataList = arrlist
                })
            } else if (type === this.$tx('ecoa.portal.other', '其他')) {
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhQtData
                    this.dataList = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
                this.$app.listdata('ecoa/dzgg/listdata', this.listdataConfig).then((res) => {
                    const arrlist = []
                    this.allDataList = res.body.pageInfo.list
                    this.allDataList.forEach((k) => {
                        if (k.type === '其它') {
                            arrlist.push(k)
                        }
                    })
                    this.dataList = arrlist
                })
            }
        },
        getAllData() {
            this.$app
                .listdata('ecoa/dzgg/listdata', this.listdataConfig)
                .then((res) => {
                    this.allDataList = res.body.pageInfo.list

                    // const length = this.allDataList.length
                    // if (length < 5 && length > 0) {
                    //     for (let i = 0; i < 5 - length; i++) {
                    //         this.allDataList.push({})
                    //         // this.header.title.push({ name: this.allDataList[i].type, code: 'dzggPublished' })
                    //     }
                    // }
                    // this.transAllData()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 全部数据列表转化
        transAllData() {
            const cateO = {}
            this.allDataList.forEach((v) => {
                if (!cateO[v.flFormName]) {
                    cateO[v.flFormName] = {
                        name: v.type,
                        click: () => {
                            this.getData(cateO[v.flFormName].dataList)
                        },
                        dataList: [],
                        code: 'dzggPublished'
                    }
                }
                cateO[v.flFormName].dataList.push(v)
            })
            const cateList = Object.values(cateO)
            const newarr = []
            cateList.forEach((item) => {
                newarr.push(item)
            })
            // this.$set(this.header, 'title', newarr)
            this.getData(newarr[0].dataList)
            newarr.forEach((item) => {
                item.dataList.push({})
            })
        },
        getData(dataList) {
            this.$set(this, 'dataList', dataList)
        },
        onCellLink(row) {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                this.$bus.emit('openDefaultDialog', this.appletData.name)
                return
            }
            if (row.id) {
                window.open('/#/viewcontent?wfEngineUrl=ecoa/dzgg&busiDataId=' + row.id + '&viewContent=1' + `&logoTitle=电子公告/${row.flSubject}`)
            }
        }
    }
}
</script>

  <style scoped lang="scss">
#tzgg-body {
    height: 100%;
    // @import url(); 引入公共css类
    #item-body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        .link-message + .link-message {
            border-top: 1px dashed #ebeef5;
            // border-top:none !important;
        }
        .link-message {
            width: 100%;
            height: 71px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            list-style: none;
            padding: 10px 20px;
            .item {
                // padding: 10px 0;
                width: 100%;
                height: 100%;
            }

            cursor: pointer;
            &:hover {
                // background-color: #F5F7FA;
            }
            &:last-child {
                border-bottom: none;
            }
            .title {
                font-size: 14px;
                color: #333333;
                height: 25px;
                line-height: 25px;
                width: 96%;
                position: relative;
                padding-right: 10px;
                display: inline-block;
                .msg {
                    display: block;
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .no-read {
                    display: block;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    background: red;
                    position: absolute;
                    left: -10px;
                    top: 12px;
                    z-index: 100;
                }
            }
            .bottom {
                font-size: 13px;
                color: #9b9b9b;
                height: 25px;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                .name {
                    display: inline-block;

                    font-size: 13px;
                }
                .time {
                    display: block;
                    width: 106px;
                    float: right;
                    margin-right: 10px;
                    font-size: 13px;
                }
                .sender {
                    font-size: 12px;
                }
            }
        }
    }
    // .autoStyle{
    //     height: 100px !important;
    //     overflow-y: auto;
    // }
    // .autoStyle::-webkit-scrollbar{
    //     display: none;
    // }
}
</style>
